import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const SquareFilledIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
      <rect
        width={23 - 2 * 2}
        height={23 - 2 * 2}
        x={2}
        y={2}
        fill="none"
        stroke="#BF295C"
        strokeWidth="1px"
        rx={4}
      />

      <path
        transform={`scale(${0.9})`}
        fill="#F56193"
        d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59L21 7Z"
      />
    </SvgIcon>
  );
};
